module.exports = __webpack_public_path__ + "static/media/points10_9.1227facd.png";